/*
  sov — Collection Facets JS (accordion in-page)
  -Ultimo aggiornamento: 2025-09-13 18:35 Europe/Rome
  prima: nessun montaggio facets in pagina
  dopo: riuso algoritmo dynamic menu (gender → brand → category) con collapsible .sov-cm
*/
(function () {
  'use strict';
  if (window.__sovCollectionFacetsBooted) return;
  window.__sovCollectionFacetsBooted = true;

  /* ============================
     toggles principali
     ============================ */
  var SOV_DEBUG = false;
  var SOV_USE_CACHE = false;

  /* ============================
     config
     ============================ */
  var CFG = {
    hostSelector: '[data-sov-cf-root]',
    tplGender: '#sov-cf-tpl-gender',
    tplBrand:  '#sov-cf-tpl-brand',
    tplCat:    '#sov-cf-tpl-cat',
    ttlRootMs:   12 * 60 * 60 * 1000,
    ttlBrandsMs:  6 * 60 * 60 * 1000,
    ttlCatsMs:    3 * 60 * 60 * 1000
  };

  /* ============================
     log helpers
     ============================ */
  function log(){ if(!SOV_DEBUG) return; try{ console.log('[sov-cf]', [].slice.call(arguments)); }catch(e){} }
  function logErr(tag, err){
    if(!SOV_DEBUG) return;
    try {
      var msg = err && (err.stack || err.message || String(err));
      console.error('[sov-cf][ERR]['+tag+']', msg, err);
    } catch(e){}
  }

  /* ============================
     telemetria: open/close con gtag
     -Ultimo aggiornamento: 2025-09-15 18:25 Europe/Rome
     prima: nessun tracciamento
     dopo: eventi 'sov_cf_toggle' con scope e label
  ============================ */
/* Telemetria pannelli Collection Facets
   -Ultimo aggiornamento: 2025-10-13 15:25 Europe/Rome
   prima: un solo evento con action variabile
   dopo: due eventi distinti e stabili: dynamic_collection_panel_open / dynamic_collection_panel_close */
function trackCfToggle(isOpen, scope, label) {
  try {
    if (typeof gtag !== 'function') return;
    var host = document.getElementById('sov-collection-facets');
    var sectionId = host ? (host.getAttribute('data-sov-cf-section-id') || '') : '';
    var evt = isOpen ? 'dynamic_collection_panel_open' : 'dynamic_collection_panel_close';
    gtag('event', evt, {
      scope: String(scope || ''),
      label: String(label || ''),
      section_id: sectionId
    });
  } catch (e) { /* no-op */ }
}


  /**
   * Osserva l'attributo aria-expanded del pannello .sov-cm
   * e invia evento open/close a ogni cambiamento.
   */
  function observeAriaExpanded(panelEl, scope, label) {
    try {
      if (!panelEl) return;
      var prev = panelEl.getAttribute('aria-expanded');

      function emit(nextVal) {
        if (nextVal === prev) return;
        prev = nextVal;
        trackCfToggle(nextVal === 'true', scope, label);
      }

      var mo = new MutationObserver(function (ml) {
        for (var i = 0; i < ml.length; i++) {
          if (ml[i].attributeName === 'aria-expanded') {
            emit(panelEl.getAttribute('aria-expanded'));
          }
        }
      });
      mo.observe(panelEl, { attributes: true, attributeFilter: ['aria-expanded'] });
    } catch (e) { /* no-op */ }
  }



  /* ============================
     micro cache localStorage
     ============================ */
  var Cache = (function(){
    var VKEY='sov:cf:version';
    var VER='v1';
    function mk(k){ return 'sov:cf:'+k; }
    function now(){ return Date.now(); }
    function bump(){
      if (!SOV_USE_CACHE) return;
      try {
        var cur = localStorage.getItem(VKEY);
        if (cur !== VER) {
          Object.keys(localStorage).forEach(function(k){ if(k.indexOf('sov:cf:')===0) localStorage.removeItem(k); });
          localStorage.setItem(VKEY, VER);
        }
      } catch(e){ logErr('cache.bump', e); }
    }
    function get(k){
      if (!SOV_USE_CACHE) return null;
      try{
        var raw = localStorage.getItem(mk(k));
        if(!raw) return null;
        var o = JSON.parse(raw);
        if(!o || !o.expiresAt || o.expiresAt < now()) return null;
        return o.value;
      }catch(e){ logErr('cache.get '+k, e); return null; }
    }
    function set(k,v,ttlMs){
      if (!SOV_USE_CACHE) return;
      try{
        localStorage.setItem(mk(k), JSON.stringify({ value:v, expiresAt: now()+Math.max(60000, ttlMs|0)}));
      }catch(e){ logErr('cache.set '+k, e); }
    }
    function clear(k){ try{ localStorage.removeItem(mk(k)); }catch(e){} }
    return { bump:bump, get:get, set:set, clear:clear };
  })();

  /* ============================
     url helpers
     ============================ */
  function resolveAllCollectionUrl(){
    try{
      var m = (window.location.pathname||'').match(/^\/([a-z]{2})(?:\/|$)/i);
      var prefix = m ? '/'+m[1].toLowerCase() : '';
      return prefix + '/collections/all?view=sov-facets.json&filter.v.availability=1';
    }catch(e){ return '/collections/all?view=sov-facets.json&filter.v.availability=1'; }
  }
  function addViewIfMissing(url){
    try{
      if(!/view=/.test(url)) return url + (url.indexOf('?')>-1?'&':'?') + 'view=sov-facets.json&filter.v.availability=1';
      return url;
    }catch(e){ return url; }
  }
  function buildFinalCollectionUrl(urlToAdd){
    try{
      var u = new URL(urlToAdd, window.location.origin);
      u.searchParams.delete('view');
      return u.pathname + (u.search ? u.search : '');
    }catch(e){ return urlToAdd || '#'; }
  }
  function readParam(url,name){
    try{ var u=new URL(url, window.location.origin); return u.searchParams.get(name); }
    catch(_){
      try{
        var rx=new RegExp('[?&]'+name.replace(/\./g,'\\.')+'=([^&]+)');
        var m=String(url||'').match(rx);
        return m?decodeURIComponent(m[1]):null;
      }catch(e2){ return null; }
    }
  }

  /* ============================
     fetch json con cache toggle
     ============================ */
  function fetchJsonWithCache(url, cacheKey, ttlMs){
    Cache.bump();
    var key = cacheKey || ('k:'+url);
    if (SOV_USE_CACHE){
      var hit = Cache.get(key);
      if (hit) { log('cache hit', key); return Promise.resolve(hit); }
    } else {
      Cache.clear(key);
    }
    var finalUrl = addViewIfMissing(url);
    return fetch(finalUrl, { credentials:'same-origin', cache:'no-store' })
      .then(function(r){ return r.ok ? r.json() : ({ filters:[], __error:true, __status:r.status }); })
      .then(function(json){
        try{
          if(!json || !Array.isArray(json.filters)) json = { filters:[], __error:true };
          if (SOV_USE_CACHE) Cache.set(key, json, ttlMs || CFG.ttlRootMs);
          return json;
        }catch(e){ logErr('fetch.then', e); return { filters:[], __error:true }; }
      })
      .catch(function(err){ logErr('fetch.catch '+finalUrl, err); return { filters:[], __error:true }; });
  }

/* ============================
   thumbnail helper
   -Ultimo aggiornamento: 2025-09-15 12:45 Europe/Rome
   prima: nessuna anteprima al livello 1
   dopo: selezione casuale tra gli ultimi 20 prodotti filtrati per il gender
============================ */
function addViewParam(url, view){
  try{
    var u = new URL(url, window.location.origin);
    u.searchParams.set('view', view);
    return u.pathname + (u.search ? u.search : '');
  }catch(_){
    var sep = url.indexOf('?')>-1 ? '&' : '?';
    return url + sep + 'view=' + encodeURIComponent(view);
  }
}

function upsertQueryParam(url, key, val){
  try{
    var u = new URL(url, window.location.origin);
    if (val === null) u.searchParams.delete(key);
    else u.searchParams.set(key, val);
    return u.pathname + (u.search ? u.search : '');
  }catch(_){
    var hasQ = url.indexOf('?')>-1;
    if (val === null) return url;
    return url + (hasQ ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(val);
  }
}


/* seleziona thumb micro; fallback a /collections/all se il branch è vuoto */
function fetchRandomThumbForUrl(urlToAdd){
  try{
    if (!urlToAdd) return Promise.resolve(null);

    // URL thumbs del branch corrente, ordinati per "creati ↓"
    var thumbsUrl = upsertQueryParam(urlToAdd, 'view', 'sov-thumbs.json');
    thumbsUrl = upsertQueryParam(thumbsUrl, 'sort_by', 'created-descending');

    function pickOne(json){
      var arr = Array.isArray(json && json.images) ? json.images : [];
      arr = arr.filter(function(it){ return it && it.src; });
      if (!arr.length) return null;
      var pick = arr[Math.floor(Math.random() * arr.length)];
      return {
        src: pick.src,
        srcset: pick.srcset || '',
        sizes: pick.sizes || '(min-width: 990px) 128px, 96px',
        alt: pick.alt || ''
      };
    }

    return fetch(thumbsUrl, { credentials:'same-origin', cache:'no-store' })
      .then(function(r){ return r.ok ? r.json() : { images: [] }; })
      .then(function(json){
        var p = pickOne(json);
        if (p) return p;

        // fallback → all collections senza filtri
        var rootUrl = resolveAllCollectionUrl();
        rootUrl = upsertQueryParam(rootUrl, 'view', 'sov-thumbs.json');
        rootUrl = upsertQueryParam(rootUrl, 'sort_by', 'created-descending');
        return fetch(rootUrl, { credentials:'same-origin', cache:'no-store' })
          .then(function(r){ return r.ok ? r.json() : { images: [] }; })
          .then(pickOne);
      })
      .catch(function(){ return null; });
  }catch(e){ return Promise.resolve(null); }
}



  /* ============================
     promise micro-cache per gender json
     ============================ */
  var __genderJsonPromiseCache = Object.create(null);
  function getGenderJsonPromise(urlToAdd){
    try{
      var url = addViewIfMissing(urlToAdd);
      var key = 'gjson:'+encodeURIComponent(url);
      if (__genderJsonPromiseCache[key]) return __genderJsonPromiseCache[key];
      __genderJsonPromiseCache[key] = fetchJsonWithCache(url, key, CFG.ttlBrandsMs);
      return __genderJsonPromiseCache[key];
    }catch(e){ logErr('getGenderJsonPromise', e); return Promise.resolve({filters:[]}); }
  }

  /* ============================
     facets helpers
     ============================ */
  function findFilterByParamName(payload, paramName){
    try{
      if(!payload || !Array.isArray(payload.filters)) return null;
      for (var i=0;i<payload.filters.length;i++){
        var f = payload.filters[i];
        if ((f.param_name||'')===paramName) return f;
      }
      return null;
    }catch(e){ return null; }
  }

  function getGenderEntriesFromRoot(root){
    try{
      var out=[], hintNames=(root && root.hints && root.hints.gender_param_names)||[];
      if(hintNames.length===0 && Array.isArray(root && root.filters)){
        for(var i=0;i<root.filters.length;i++){
          var pn = root.filters[i].param_name||'';
          if (pn.indexOf('filter.p.m.custom.for_')===0) hintNames.push(pn);
        }
      }
      for (var k=0;k<hintNames.length;k++){
        var pn = hintNames[k];
        var f = findFilterByParamName(root, pn);
        if(!f || !Array.isArray(f.values)) continue;
        var trueVal = null;
        for (var j=0;j<f.values.length;j++){
          var v=f.values[j];
          if (v.url_to_add && /=(1|true)(&|$)/.test(v.url_to_add)) { trueVal=v; break; }
        }
        var key =
          pn.indexOf('.for_her')>-1  ? 'for_her'  :
          pn.indexOf('.for_him')>-1  ? 'for_him'  :
          pn.indexOf('.for_home')>-1 ? 'for_home' : pn;
        out.push({
          key:key,
          paramName:pn,
          label:(f.label||key),
          urlToAdd:trueVal?trueVal.url_to_add:null,
          count:trueVal?(trueVal.count|0):0,
          disabled:!trueVal || (trueVal.count|0)===0
        });
      }
      return out;
    }catch(e){ logErr('getGenderEntriesFromRoot', e); return []; }
  }

  function filterPreferDeepest(nodes){
    try{
      if(!Array.isArray(nodes) || nodes.length<=1) return nodes||[];
      var byKey=Object.create(null), keys=[];
      nodes.forEach(function(n){ var k=n.__catKey||''; byKey[k]=n; keys.push(k); });
      function isChildOf(parentKey, childKey){ return childKey!==parentKey && childKey.indexOf(parentKey+'-')===0; }
      var keep=[];
      for (var i=0;i<keys.length;i++){
        var k=keys[i], node=byKey[k], sumChildren=0;
        for (var j=0;j<keys.length;j++){ var other=keys[j]; if (isChildOf(k,other)) sumChildren+=(byKey[other].count|0); }
        if (sumChildren>0 && (node.count|0)<=sumChildren) continue;
        keep.push(node);
      }
      return keep;
    }catch(e){ logErr('filterPreferDeepest', e); return nodes||[]; }
  }

  function verifyCategoriesByResultsCount(categoryNodes, concurrency, catParamName){
    try{
      var limit=Math.max(1, concurrency||4);
      var queue=(categoryNodes||[]).slice();
      var out=[], seen=Object.create(null), running=0;
      return new Promise(function(resolve){
        function pump(){
          try{
            if(!queue.length && running===0){ resolve(out); return; }
            while(running<limit && queue.length){
              (function(){
                var node=queue.shift(); running++;
                var key=node.__catKey || readParam(node.urlToAdd, catParamName||'filter.p.t.category') || node.urlToAdd;
                if(seen[key]){ running--; pump(); return; }
                var url=addViewIfMissing(node.urlToAdd);
                var ck='verify:'+encodeURIComponent(url);
                fetchJsonWithCache(url, ck, 60*60*1000).then(function(json){
                  try{
                    var rc = (json && typeof json.results_count==='number') ? json.results_count : 0;
                    if(rc>0){ seen[key]=1; node.count=rc; out.push(node); }
                  }catch(e){ logErr('verify.parse', e); }
                }).finally(function(){ running--; pump(); });
              })();
            }
          }catch(e){ logErr('verify.pump', e); resolve(out); }
        }
        pump();
      });
    }catch(e){ logErr('verify', e); return Promise.resolve([]); }
  }

  function listBrandsForGender(genderUrlToAdd){
    try{
          /* -Ultimo aggiornamento: 2025-10-13 14:40 Europe/Rome
       prima: caricava sempre i brand
       dopo: ritorno immediato se SHOW_VENDORS === false */
    if (window.SHOW_VENDORS === false) return Promise.resolve([]);
      if(!genderUrlToAdd) return Promise.resolve([]);
      var url = addViewIfMissing(genderUrlToAdd);
      var ck  = 'brands:'+encodeURIComponent(url);
      return fetchJsonWithCache(url, ck, CFG.ttlBrandsMs).then(function(json){
        try{
          var brandParam=(json && json.hints && json.hints.brand_param_name)||'filter.p.vendor';
          var f = findFilterByParamName(json, brandParam);
          var arr=[];
          if (f && Array.isArray(f.values)){
            f.values.forEach(function(v){
              if(!v || !v.url_to_add) return;
              arr.push({
                label: v.label||'',
                count: v.count|0,
                urlToAdd: v.url_to_add,
                slug: (v.label||'').toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9\-]/g,'')
              });
            });
            /* filtra i brand con conteggio 0 per non renderizzarli */
            arr = arr.filter(function(b){ return (b.count|0) > 0; });
          }          
          arr.sort(function(a,b){ return a.label.localeCompare(b.label); }); /* alfabetico, nessun top-N */
          arr = arr.filter(function(b){ return (b.count|0) > 0; });
          return arr;
        }catch(e){ logErr('brands.parse', e); return []; }
      });
    }catch(e){ logErr('brands', e); return Promise.resolve([]); }
  }

  function listCategoriesForBrand(brandUrlToAdd){
    try{
      if(!brandUrlToAdd) return Promise.resolve([]);
      var url = addViewIfMissing(brandUrlToAdd);
      var ck  = 'cats:'+encodeURIComponent(url);
      return fetchJsonWithCache(url, ck, CFG.ttlCatsMs).then(function(json){
        try{
          var catParam=(json && json.hints && json.hints.category_param_name)||'filter.p.t.category';
          var f = findFilterByParamName(json, catParam);
          var arr=[], seen=Object.create(null);
          if (f && Array.isArray(f.values)){
            f.values.forEach(function(v){
              if(!v || !v.url_to_add) return;
              var catKey = readParam(v.url_to_add, catParam) || v.url_to_add;
              if(seen[catKey]) return;
              seen[catKey]=1;
              arr.push({ label:v.label||'', count:v.count|0, urlToAdd:v.url_to_add, __catKey:catKey });
            });
          }
          arr.sort(function(a,b){ return (a.label||'').localeCompare(b.label||''); }); /* alfabetico */
          return verifyCategoriesByResultsCount(arr, 4, catParam).then(function(verified){
            try{
              var deepest = filterPreferDeepest(verified);
              deepest.sort(function(a,b){ return (a.label||'').localeCompare(b.label||''); }); /* alfabetico finale */
              return deepest;
            }catch(e){ logErr('cats.post', e); return verified||[]; }
          });
        }catch(e){ logErr('cats.parse', e); return []; }
      });
    }catch(e){ logErr('cats', e); return Promise.resolve([]); }
  }

  /* ============================
     template helpers (no innerHTML per testo dinamico)
     ============================ */
  function cloneTpl(tplId, map){
    try{
      var t=document.querySelector(tplId);
      if(!t || !t.content) return null;
      var node=t.content.firstElementChild.cloneNode(true);
      bindPlaceholders(node, map||{});
      return node;
    }catch(e){ logErr('cloneTpl '+tplId, e); return null; }
  }
  function bindPlaceholders(root, map){
    try{
      var rx=/__(\w+)__/g;
      var tw=document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var n;
      while((n=tw.nextNode())){
        n.nodeValue = n.nodeValue.replace(rx, function(_,k){ return map.hasOwnProperty(k)? String(map[k]) : ''; });
      }
      root.querySelectorAll('*').forEach(function(el){
        Array.prototype.slice.call(el.attributes).forEach(function(a){
          var v=a.value.replace(rx, function(_,k){ return map.hasOwnProperty(k)? String(map[k]) : ''; });
          if(v!==a.value) el.setAttribute(a.name, v);
        });
      });
    }catch(e){ logErr('bindPlaceholders', e); }
  }
  function clearChildren(el){ try{ while(el && el.firstChild) el.removeChild(el.firstChild); }catch(e){} }

  /* ============================
     accordion wiring su .sov-cm
     ============================ */
function listCategoriesForGenderFromJson(genderJson){
  try{
    var catParam=(genderJson && genderJson.hints && genderJson.hints.category_param_name)||'filter.p.t.category';
    var f = findFilterByParamName(genderJson, catParam);
    var arr=[], seen=Object.create(null);
    if (f && Array.isArray(f.values)){
      f.values.forEach(function(v){
        if(!v || !v.url_to_add) return;
        var catKey = readParam(v.url_to_add, catParam) || v.url_to_add;
        if(seen[catKey]) return;
        seen[catKey]=1;
        arr.push({ label:v.label||'', count:v.count|0, urlToAdd:v.url_to_add, __catKey:catKey });
      });
      /* riduce carico: rimuove categorie con conteggio 0 */
      arr = arr.filter(function(it){ return (it.count|0) > 0; });
    }
    return verifyCategoriesByResultsCount(arr, 4, catParam).then(function(verified){
      try{
        var deepest = filterPreferDeepest(verified);
        deepest.sort(function(a,b){ return (a.label||'').localeCompare(b.label||''); }); /* alfabetico */
        return deepest;
      }catch(e){ logErr('cats.gender.post', e); return verified||[]; }
    });
  }catch(e){ logErr('listCategoriesForGenderFromJson', e); return Promise.resolve([]); }
}

  function wireAccordion(container){
    try{
      document.addEventListener('cm:open', function(ev){
        try{
          var panelId = ev && ev.detail && ev.detail.panel_id ? ev.detail.panel_id : '';
          if(!panelId) return;
          var panel = document.getElementById(panelId);
          if(!panel) return;
          var parent = panel.parentElement;
          if(!parent) return;

          /* chiudi i fratelli aperti con click sull'header per rispettare animazione */
          var siblings = parent.querySelectorAll(':scope > .sov-cm[aria-expanded="true"], :scope > li > .sov-cm[aria-expanded="true"]');
          siblings.forEach(function(p){
            if (p===panel) return;
            var header = p.querySelector('.sov-cm__header');
            if (header) header.click();
          });
        }catch(e){ logErr('accordion.handler', e); }
      });
    }catch(e){ logErr('wireAccordion', e); }
  }

  /* ============================
     mount
     ============================ */
  function showStatus(statusEl){ if(!statusEl) return; statusEl.hidden=false; statusEl.setAttribute('aria-busy','true'); var sp=statusEl.querySelector('.loading__spinner'); if(sp) sp.classList.remove('hidden'); }
  function hideStatus(statusEl){ if(!statusEl) return; statusEl.setAttribute('aria-busy','false'); var sp=statusEl.querySelector('.loading__spinner'); if(sp) sp.classList.add('hidden'); requestAnimationFrame(function(){ statusEl.hidden=true; }); }

function insertGender(host, g){
  var el = cloneTpl(CFG.tplGender, { GENDER_LABEL: g.label||g.key });
  if(!el) return;

  // id per eventi cm:open (accordion)
  var gid = 'sov-cf-g-'+(g.key||'k')+'-'+Math.random().toString(36).slice(2,8);
  el.id = gid;

  if (window.SovCollapsiblePanel) window.SovCollapsiblePanel.initOne(el);

  /* telemetria: pannello gender (L1) */
  observeAriaExpanded(el, 'gender', g.key);

  var statusEl   = el.querySelector('[data-sov-cf-status]');
  var brandsHost = el.querySelector('[data-sov-cf-brands-host]');
  var brandsPanel= el.querySelector('[data-sov-cf-brands-panel]');
  var brandsTitle= el.querySelector('[data-sov-cf-brands-title]');

  var catsHost   = el.querySelector('[data-sov-cf-cats-host]');
  var catsPanel  = el.querySelector('[data-sov-cf-cats-panel]');
  var catsTitle  = el.querySelector('[data-sov-cf-cats-title]');

/* -Ultimo aggiornamento: 2025-10-13 14:40 Europe/Rome
   prima: pannello brand sempre presente
   dopo: rimozione definitiva del pannello brand quando SHOW_VENDORS === false */
if (window.SHOW_VENDORS === false) {
  if (brandsPanel && brandsPanel.parentNode) brandsPanel.parentNode.removeChild(brandsPanel);
  if (brandsTitle && brandsTitle.parentNode) brandsTitle.parentNode.removeChild(brandsTitle);
  brandsPanel = null;
  brandsTitle = null;
  brandsHost  = null;
}


  /* id univoci per l’accordion di livello 2 */
/* id univoci per l’accordion di livello 2 */
if (catsPanel)   catsPanel.id   = gid + '-cats';
if (brandsPanel) brandsPanel.id = gid + '-brands';

if (window.SovCollapsiblePanel){
  if (catsPanel) window.SovCollapsiblePanel.initOne(catsPanel);
  if (window.SHOW_VENDORS !== false && brandsPanel) window.SovCollapsiblePanel.initOne(brandsPanel);
}

/* telemetria: sotto-pannelli del gender
   -Ultimo aggiornamento: 2025-10-13 14:40 Europe/Rome */
if (catsPanel) observeAriaExpanded(catsPanel, 'gender_categories', g.key);
if (window.SHOW_VENDORS !== false && brandsPanel) observeAriaExpanded(brandsPanel, 'gender_brands', g.key);


/* thumbnail L1: popolamento lazy appena il nodo entra nel DOM */
try{
  var thumbImg = el.querySelector('[data-sov-cf-thumb]');
  if (thumbImg && g && g.urlToAdd){
    fetchRandomThumbForUrl(g.urlToAdd).then(function(pick){
      try{
        if (!pick || !pick.src) return;
  /* impostare prima srcset/sizes, poi src per evitare flash “broken” */
  if (pick.srcset) thumbImg.srcset = pick.srcset;
  thumbImg.sizes = pick.sizes;
  thumbImg.alt = '';               /* decorativo in header L1 */
  thumbImg.fetchPriority = 'low';  /* nessuna priorità indebitamente alta */

  /* src micro immediato → niente icona rotta, niente over-fetch */
  thumbImg.src = pick.src;
      }catch(e){}
    });
  }
}catch(e){}


  var loaded = false;

  el.querySelector('.sov-cm__header').addEventListener('click', function(){
    if (loaded) return;
    loaded = true;
    showStatus(statusEl);

    var genderJsonP = getGenderJsonPromise(g.urlToAdd);

    var t1 = genderJsonP.then(function(json){
      try{
        var brandParam=(json && json.hints && json.hints.brand_param_name)||'filter.p.vendor';
        var catParam  =(json && json.hints && json.hints.category_param_name)||'filter.p.t.category';
        var brandFilter = findFilterByParamName(json, brandParam);
        var catFilter   = findFilterByParamName(json, catParam);
/* -Ultimo aggiornamento: 2025-10-13 14:40 Europe/Rome */
if (catsTitle && catFilter && catFilter.label) catsTitle.textContent = String(catFilter.label);
if (window.SHOW_VENDORS !== false && brandsTitle && brandFilter && brandFilter.label) {
  brandsTitle.textContent = String(brandFilter.label);
}

        // CATEGORIE del gender
        if (catsHost && catsHost.getAttribute('data-loaded')!=='1'){
          return listCategoriesForGenderFromJson(json).then(function(items){
            clearChildren(catsHost);
            catsHost.setAttribute('data-loaded','1');
            if(!items.length){
              var li=document.createElement('li'); li.textContent='—'; catsHost.appendChild(li);
              return;
            }
            items.forEach(function(it){
              var ce = cloneTpl(CFG.tplCat, {
                HREF: buildFinalCollectionUrl(it.urlToAdd),
                CAT_LABEL: it.label,
                CAT_COUNT: (it.count|0)
              });
              if (ce){
                var a=ce.querySelector('a'); if(a) a.setAttribute('href', buildFinalCollectionUrl(it.urlToAdd));
                catsHost.appendChild(ce);
              }
            });
          });
        }
      }catch(e){ logErr('gender.populate.cats', e); }
    });

    /* -Ultimo aggiornamento: 2025-10-13 14:40 Europe/Rome
   prima: caricava sempre i brand
   dopo: nessun caricamento quando SHOW_VENDORS === false */
var t2 = (window.SHOW_VENDORS === false)
  ? Promise.resolve()
  : listBrandsForGender(g.urlToAdd).then(function(brands){
      try{
        clearChildren(brandsHost);
        if(!brands.length){
          var li=document.createElement('li'); li.textContent='—'; brandsHost.appendChild(li);
          return;
        }
        brands.forEach(function(b){
          var be = cloneTpl(CFG.tplBrand, { BRAND_LABEL:b.label, BRAND_COUNT:(b.count|0) });
          if(!be) return;

          var bid = 'sov-cf-b-'+(b.slug||'b')+'-'+Math.random().toString(36).slice(2,8);
          var bePanel = be.querySelector('.sov-cm');
          bePanel.id = bid;

          if (window.SovCollapsiblePanel) window.SovCollapsiblePanel.initOne(bePanel);

          /* telemetria: pannello brand (L2) */
          observeAriaExpanded(bePanel, 'brand', b.slug || '');

          var catsHostB = be.querySelector('[data-sov-cf-cats-host]');
          var stBrand   = be.querySelector('[data-sov-cf-status]');
          var bLoaded   = false;

          be.querySelector('.sov-cm__header').addEventListener('click', function(){
            if (bLoaded) return;
            bLoaded = true;
            showStatus(stBrand);
            listCategoriesForBrand(b.urlToAdd).then(function(items){
              try{
                clearChildren(catsHostB);
                if(!items.length){
                  var li=document.createElement('li'); li.textContent='Nessuna categoria'; catsHostB.appendChild(li);
                  return;
                }
                items.forEach(function(it){
                  var ce = cloneTpl(CFG.tplCat, {
                    HREF: buildFinalCollectionUrl(it.urlToAdd),
                    CAT_LABEL: it.label,
                    CAT_COUNT: (it.count|0)
                  });
                  if(ce){
                    var a=ce.querySelector('a'); if(a) a.setAttribute('href', buildFinalCollectionUrl(it.urlToAdd));
                    catsHostB.appendChild(ce);
                  }
                });
              }catch(e){ logErr('brand.cats.render', e); }
            }).finally(function(){ hideStatus(stBrand); });
          });

          brandsHost.appendChild(be);
        });
      }catch(e){ logErr('gender.brands.render', e); }
    });


    Promise.all([t1, t2]).finally(function(){ hideStatus(statusEl); });
  });

  host.appendChild(el);
}


  function mountOne(host){
  try{
    if (!host || host.getAttribute('data-sov-cf-ready') === 'true') return;

    wireAccordion(host);

    var initStatus = host.querySelector('[data-sov-cf-init-status]');
    showStatus(initStatus);

    function populate(rootJson){
      try{
        var genders = getGenderEntriesFromRoot(rootJson)
          .filter(function(g){ return !g.disabled && (g.count|0)>0; });

        var orderMap = { for_her:1, for_him:2, for_home:9 };
        genders.sort(function(a,b){
          var oa=(orderMap[a.key]||99), ob=(orderMap[b.key]||99);
          if (oa!==ob) return oa-ob;
          return (a.label||'').localeCompare(b.label||'');
        });

        genders.forEach(function(g){ insertGender(host, g); });
        host.setAttribute('data-sov-cf-ready','true');
      }catch(e){ logErr('mountOne.populate', e); }
    }

    if (window.SOV && SOV.facets && typeof SOV.facets.ensureRoot === 'function') {
      SOV.facets.ensureRoot()
        .then(populate)
        .catch(function(e){ logErr('mountOne.ensureRoot', e); })
        .finally(function(){ hideStatus(initStatus); });
    } else {
      document.addEventListener('sov:facets:root:ready', function(ev){
        try{
          var rootJson = ev && ev.detail && ev.detail.payload;
          if (rootJson) populate(rootJson);
        }catch(e){ logErr('mountOne.readyHandler', e); }
        finally { hideStatus(initStatus); }
      }, { once:true });
    }
  }catch(e){ logErr('mountOne', e); }
}

function mount(){
  try{
    var hosts = document.querySelectorAll(CFG.hostSelector);
    if(!hosts.length){ log('host non trovato'); return; }
    hosts.forEach(mountOne);
  }catch(e){ logErr('mount', e); }
}

/* consenti il mount “su richiesta” (post-idratazione, toggle, ecc.) */
document.addEventListener('sov:cf:mount', function(ev){
  try{
    var host = ev && ev.detail && ev.detail.host;
    if(host) mountOne(host);
  }catch(e){ logErr('evt sov:cf:mount', e); }
});



  if (document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', mount, { once:true });
  } else {
    mount();
  }
})();
/* SOV — Toggle delegato + mount lazy dell'inline menu */
(function(){
  if (window.__sovDynmenuBinder) return;
  window.__sovDynmenuBinder = true;

    /* telemetria product-count toggle
     -ultimo aggiornamento: 2025-09-26 11:15 (europe/rome)
     prima: nessun tracciamento apertura/chiusura
     dopo: eventi gtag facets_productcount_open/close con metadati minimi */
  function trackProductCountToggle(isOpen, reason) {
    try {
      if (typeof gtag !== 'function') return;

      var host = document.getElementById('sov-collection-facets');
      var sectionId = host ? (host.getAttribute('data-sov-cf-section-id') || '') : '';
      var locale =
        (window.Shopify && Shopify.locale) ? Shopify.locale :
        (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : '';
      var context = window.matchMedia && window.matchMedia('(max-width: 989px)').matches ? 'mobile' : 'desktop';

      gtag('event', isOpen ? 'facets_productcount_open' : 'facets_productcount_close', {
        section_id: sectionId,
        context: context,
        locale: String(locale || ''),
        reason: String(reason || 'toggle')
      });
    } catch (_) { /* no-op */ }
  }

    // crea o recupera la backdrop correlata al pannello
  function getOrEnsureBackdrop(panelEl){
    try{
      // cerca nel container dei filtri, poi nel documento
      var container = panelEl.closest('#main-collection-filters') || document;
      var bd = container.querySelector('.sov-dynmenu__backdrop') || document.querySelector('.sov-dynmenu__backdrop');
      if (bd) return bd;

      // crea una nuova backdrop come sorella del pannello
      bd = document.createElement('div');
      bd.className = 'sov-dynmenu__backdrop';
      bd.setAttribute('hidden','');
      (panelEl.parentElement || document.body).appendChild(bd);
      return bd;
    }catch(_){ return null; }
  }


  document.addEventListener('click', function(ev){
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-sov-dynmenu-toggle]');
    if (!btn) return;

    var panelId = btn.getAttribute('aria-controls') || '';
    var panel   = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

  
    var backdrop = getOrEnsureBackdrop(panel);


    var willOpen = panel.hasAttribute('hidden');
    if (willOpen){
      panel.removeAttribute('hidden');
      btn.setAttribute('aria-expanded','true');

          /* backdrop on */
    if (backdrop) backdrop.removeAttribute('hidden');
      /* telemetria: apertura esplicita da toggle */
      trackProductCountToggle(true, 'toggle');      

      // al primo open esegui il mount del menu inline
      var host = panel.querySelector('[data-sov-cf-root]');
      if (host && host.getAttribute('data-sov-cf-ready') !== 'true'){
        try {
          document.dispatchEvent(new CustomEvent('sov:cf:mount', { detail: { host: host } }));
        } catch(_) {}
      }
    } else {
      panel.setAttribute('hidden','');
      btn.setAttribute('aria-expanded','false');

          /* backdrop off */
    if (backdrop) backdrop.setAttribute('hidden','');

      /* telemetria: chiusura esplicita da toggle */
      trackProductCountToggle(false, 'toggle');

    }
  }, true);

/* chiusura tramite click/tap sulla backdrop
   -ultimo aggiornamento: 2025-09-26 13:15 (europe/rome) */
document.addEventListener('click', function(ev){
  var bd = ev.target && ev.target.closest && ev.target.closest('.sov-dynmenu__backdrop');
  if (!bd) return;

  /* chiude il pannello attualmente aperto (se presente) */
  try{
    var openPanel = document.querySelector('.sov-dynmenu__panel:not([hidden])');
    if (openPanel) openPanel.setAttribute('hidden','');

    var btn = openPanel ? document.querySelector('[data-sov-dynmenu-toggle][aria-controls="' + openPanel.id + '"]') : null;
    if (btn) btn.setAttribute('aria-expanded','false');

    /* nasconde la backdrop */
    /*bd.setAttribute('hidden','');*/

    /* telemetria: chiusura via backdrop */
    trackProductCountToggle(false, 'backdrop');
  }catch(_){}
}, true);



})();
